import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { OrderTrackingModalPage } from './order-tracking-modal.page';

import { PipesModule } from '../../shared/pipes/pipes.module';

import { GoogleMapsOrderTrackingComponentModule } from '../../shared/components/google-maps-order-tracking/google-maps-order-tracking.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule.forChild(), PipesModule, GoogleMapsOrderTrackingComponentModule],
  declarations: [OrderTrackingModalPage],
})
export class OrderTrackingModalPageModule {}
